/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UnderlineInputs */

const en_underline = /** @type {(inputs: UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underline`)
};

const fr_underline = /** @type {(inputs: UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souligné`)
};

const de_underline = /** @type {(inputs: UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstreichen`)
};

const it_underline = /** @type {(inputs: UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottolineare`)
};

const ru_underline = /** @type {(inputs: UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подчеркнуть`)
};

const es_underline = /** @type {(inputs: UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subrayar`)
};

const zh_cn2_underline = /** @type {(inputs: UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强调`)
};

const ja_underline = /** @type {(inputs: UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下線`)
};

const hi_underline = /** @type {(inputs: UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रेखांकन`)
};

const pt_pt2_underline = /** @type {(inputs: UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sublinhado`)
};

/**
* | output |
* | --- |
* | "Underline" |
*
* @param {UnderlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const underline = /** @type {((inputs?: UnderlineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UnderlineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_underline(inputs)
	if (locale === "de") return de_underline(inputs)
	if (locale === "it") return it_underline(inputs)
	if (locale === "ru") return ru_underline(inputs)
	if (locale === "es") return es_underline(inputs)
	if (locale === "zh-CN") return zh_cn2_underline(inputs)
	if (locale === "ja") return ja_underline(inputs)
	if (locale === "hi") return hi_underline(inputs)
	if (locale === "pt-PT") return pt_pt2_underline(inputs)
	return en_underline(inputs)
});